import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import {FormattedDate} from 'react-intl';

import {DATESTAMP_MONTH_DATE_HIGHLIGHT} from './config';
import {CalendarTBD} from './icons';

import '../styles/index.scss';

const themeDateStampColor = (theme = {}, cxs) =>
  theme.paletteSecondary &&
  cxs &&
  cxs({
    color: `${theme.paletteSecondary} !important`,
    fill: `${theme.paletteSecondary} !important`,
  });

/**
 *  DateStamp
 * @TODO dateStampYear
 * @TODO dateStamp-small, dateStamp-large
 */
export const DateStamp = ({date, theme, className, themeProvider, time, isAllEvents = false}) => {
  const themeDateStampColorClass = themeDateStampColor(theme, themeProvider);

  const isCurrentYear =
    date && date instanceof Date && date.getFullYear() === new Date().getFullYear() ? undefined : {year: 'numeric'};

  const timeDisplay = isAllEvents ? (
    <time>
      <span className={cs('DateStamp__MonthDateYear', themeDateStampColorClass)}>
        <span>
          <FormattedDate value={date} month="short" day="numeric" {...isCurrentYear} />
        </span>
      </span>
    </time>
  ) : (
    <time>
      <span className={cs('DateStamp__Day', 'DateStamp__Day--highlight', themeDateStampColorClass)}>
        <span>
          <FormattedDate value={date} month="short" day="numeric" {...isCurrentYear} />
        </span>
      </span>
      <span className={cs('DateStamp__MonthDateYear', themeDateStampColorClass)}>
        <div className="DateStamp__Weekday">
          <FormattedDate value={date} weekday="short" />
        </div>
        <div className="DateStamp__Time">{time}</div>
      </span>
    </time>
  );

  const eventDate = time ? (
    timeDisplay
  ) : theme && theme.dateTimeStampType === DATESTAMP_MONTH_DATE_HIGHLIGHT ? (
    <time>
      <span className={cs('DateStamp__Month', 'DateStamp__Month--highlight', themeDateStampColorClass)}>
        <FormattedDate value={date} month="short" />
      </span>
      <span className={cs('DateStamp__Date', 'DateStamp__Date--highlight', themeDateStampColorClass)}>
        <FormattedDate value={date} day="2-digit" />
      </span>
      <span className="DateStamp__Day--small">
        <FormattedDate value={date} weekday="short" />
      </span>
    </time>
  ) : (
    <time>
      <span className={cs('DateStamp__Day', 'DateStamp__Day--highlight', themeDateStampColorClass)}>
        <span>
          <FormattedDate value={date} month="short" day="numeric" {...isCurrentYear} />
        </span>
      </span>
      <span className={cs('DateStamp__MonthDateYear', themeDateStampColorClass)}>
        <div className="DateStamp__Weekday">
          <FormattedDate value={date} weekday="short" />
        </div>
        <div className="DateStamp__Time">{time}</div>
      </span>
    </time>
  );

  const tbdIconDate = (
    <div className="DateStamp__TBD">
      <span className={cs('DateStamp__TBDIcon', themeDateStampColorClass)}>
        <CalendarTBD />
      </span>
    </div>
  );

  const timestamp = date && date instanceof Date ? date.getTime() : 'tbd';

  const isValidDate = date && date instanceof Date && !isNaN(date.getTime());

  return (
    <div className={cs('DateStamp', className)} data-timestamp={timestamp}>
      {isValidDate ? eventDate : tbdIconDate}
    </div>
  );
};

DateStamp.propTypes = {
  /**
   * The Date Object for the Constructing the Date
   *
   */
  date: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  theme: PropTypes.object,

  /**
   * Custom class name to add to the outer element
   */
  className: PropTypes.string,

  /**
   * ThemeProvider object for applying the theme.
   *
   */
  themeProvider: PropTypes.func,
  time: PropTypes.string,
  isAllEvents: PropTypes.bool,
};

export default DateStamp;
